// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-support-tickets-section .p-datatable .p-datatable-wrapper{padding-bottom:125px}", ""]);
// Exports
module.exports = exports;
